<ol class="breadcrumb">
  <li>
    <a routerLink="/home">
      <i class="icon-home"></i> Home</a>
  </li>
  <li class="active">To do</li>
</ol>
<h1>
  To do
</h1>

<div>
  @if (profileId == 4) {
  <app-table-todo-reports [employeeId]="employeeId">Todo reports</app-table-todo-reports>
  }
  @if (profileId != 4) {
  <app-table-todo-report [employeeId]="employeeId">Todo reports</app-table-todo-report>
  }
</div>
